var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DealDetails"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('dealDetailsTabBill'),"name":"bill"}},[_c('DealBillTable',{attrs:{"deal":_vm.deal}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }